import javascriptBridge from '@/core/lib/javascript-bridge';
import { DESIGNER_HOMEPAGEOFOTHERS } from '@/utils/consts/app-page';
import store from '@/store';
import { jumpToLogin } from '@/utils/helpers/ssoPlus';
import { getCookie } from './index';

export const isLogin = !!getCookie('Swj.Share') || !!getCookie('Magiccube-Token');

/**
 * 检查登录状态
 */
export function checkLogin() {
  const { swjApp } = javascriptBridge.device;
  if (!isLogin) {
    if (swjApp) {
      javascriptBridge.navigateTo({
        name: 'Login',
        params: {
          redirectUrl: window.location.href,
        },
      });
    } else {
      // 跳转登录
      jumpToLogin();
    }
  } else if (!swjApp) {
    // 埋点需求
    if (!store.state.user.roleId) {
      store.dispatch('user/getRoleId');
    }
  }
  return isLogin;
}

/**
 * 跳转个人主页
 * @param {String} homepageId 方案ID
 */
export function openHomePage(homepageId) {
  javascriptBridge.navigateTo({ name: DESIGNER_HOMEPAGEOFOTHERS, params: { homepageId } });
}
